import React, { useContext } from 'react';
import { Route, Switch } from 'react-router';
import universal from 'react-universal-component';

import { UserContext } from 'Context/user';

import { defaultLazyLoadOptions } from 'Utilities/constants';

import Status404 from '../../error/404';
import {
  CUSTOMER_HUB_MILEAGE_ROUTE,
  CUSTOMER_HUB_RESULT_ROUTE,
  CUSTOMER_HUB_VALUATION_ROUTE,
} from '../CustomerHubHelpers';

const HubResult = universal(() => import('./HubResult/HubResult'), defaultLazyLoadOptions);
const TrackerHome = universal(() => import('./TrackerHome/TrackerHome'), defaultLazyLoadOptions);
const TrackerSignIn = universal(() => import('./TrackerSignIn/TrackerSignIn'), defaultLazyLoadOptions);

const CustomerHub = () => {
  const { userState } = useContext(UserContext);
  const isUserValid = Number.isInteger(userState?.id);

  return (
    <Switch>
      <Route
        exact
        path={[CUSTOMER_HUB_VALUATION_ROUTE, CUSTOMER_HUB_MILEAGE_ROUTE]}
      >
        <TrackerHome />
      </Route>
      <Route
        exact
        path={CUSTOMER_HUB_RESULT_ROUTE}>
        {isUserValid ? <HubResult /> : <TrackerSignIn />}
      </Route>
      <Route render={() => (<Status404 />)} />
    </Switch>
  );
};

export default CustomerHub;
